import * as React from "react"
import { useReadInvitationRecipientQuery } from "@digits-graphql/frontend/graphql-public"
import useRouter from "@digits-shared/hooks/useRouter"
import { useOnboardingRedirect } from "src/frontend/components/Public/hooks/useOnboardingRedirect"

export function useReadInvitationRecipient() {
  const {
    location: { queryParams },
  } = useRouter()

  const { redirectToOnboarding } = useOnboardingRedirect()

  const { data: recipientData } = useReadInvitationRecipientQuery({
    variables: {
      token: queryParams?.t || "",
    },
    context: { publicAPI: true },
    skip: !!redirectToOnboarding || !queryParams?.t,
  })

  return React.useMemo(
    () => ({
      recipientData,
    }),
    [recipientData]
  )
}
